import React from 'react'
import {Link} from 'gatsby'
import { navigate } from 'gatsby-link'
import {useForm} from 'react-hook-form';
import Layout from '../../components/Layout'
import findUsFB from '../../img/social/FindUs-FB-RGB.svg'
import useSiteMetadata from "../../components/SiteMetadata";
import {Helmet} from "react-helmet";

function encode(data) {
    return Object.keys(data)
        .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
        .join('&')
}

const Index = () => {
    const {
        register,
        handleSubmit,
        formState: { isSubmitting, isValid, errors  }
    } = useForm({ mode: 'onBlur' });
    const { title: siteTitle } = useSiteMetadata();

    const submit = async (values, e) => {
        const form = e.target;
        return fetch('/api/contact', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: encode({
                'form-name': form.getAttribute('name'),
                ...values,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    console.error(`${response.status} ${response.statusText} ${response.body}`);
                    alert("エラーにより送信できませんでした。内容をご確認の上、時間をおいてから再度お試しください。");
                    return false;
                } else {
                    navigate(form.getAttribute('action'))
                    return true;
                }
            })
            .catch((error) => {
                alert(error);
                return false;
            });
    };

    return (
        <Layout page="contact">
            <Helmet>
                <title>{siteTitle} - Contact</title>
            </Helmet>
            <div className="osi-contents">
                <div className="content">
                    <h1 className="title is-3">コンタクト</h1>
                    <hr />
                    <h2 className="title is-4">ご注意</h2>
                    <ul>
                        <li>勧誘・セールス・サービス・人材派遣・M&A等のご提案は、受け付けておりません。</li>
                        <li>現在、求人は行っておりません。</li>
                    </ul>
                    <p>※上記のお問い合わせには個別に回答しておりませんので悪しからずご了承ください。</p>
                </div>
                <div className="contact mb-5">
                    <Link to="https://www.facebook.com/OPENSPHERE.co.jp/" title="FindUs FB">
                        <img src={findUsFB} alt="Facebook" style={{ width: '200px' }} />
                    </Link>
                </div>
                <div className="content">
                    <h2 className="title is-4">お問い合わせフォーム</h2>
                    <form
                        name="contact"
                        method="post"
                        action={'/contact/thanks'}
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                        onSubmit={handleSubmit(submit)}
                        data-static-form-name="contact"
                    >
                        <input type="hidden" name="form-name" value="contact" />
                        <div hidden>
                            <label>
                                Don't fill this out:{' '}
                                <input { ...register("bot-field")} />
                            </label>
                        </div>
                        <div className="field">
                            <label className="label" htmlFor={'company'}>
                                貴社名 <span className="has-text-danger is-size-7">※必須</span>
                            </label>
                            <div className="control">
                                <input
                                    className="input"
                                    type={'text'}
                                    required={true}
                                    disabled={isSubmitting}
                                    { ...register(
                                        "company",
                                        {
                                            required: { value: true, message: "貴社名は必須です" },
                                        },
                                    ) }
                                />
                            </div>
                        </div>
                        { errors.company ? (
                            <div className="field">
                                <p className="help is-danger">
                                    { errors.company.message }
                                </p>
                            </div>
                        ) : null }
                        <div className="field">
                            <label className="label" htmlFor={'name'}>
                                お名前 <span className="has-text-danger is-size-7">※必須</span>
                            </label>
                            <div className="control">
                                <input
                                    className="input"
                                    type={'text'}
                                    required={true}
                                    disabled={isSubmitting}
                                    { ...register(
                                        "name",
                                        {
                                            required: { value: true, message: "お名前は必須です" },
                                        },
                                    ) }
                                />
                            </div>
                        </div>
                        { errors.name ? (
                            <div className="field">
                                <p className="help is-danger">
                                    { errors.name.message }
                                </p>
                            </div>
                        ) : null }
                        <div className="field">
                            <label className="label" htmlFor={'email'}>
                                E-Mail <span className="has-text-danger is-size-7">※必須</span>
                            </label>
                            <div className="control">
                                <input
                                    className="input"
                                    type={'email'}
                                    required={true}
                                    disabled={isSubmitting}
                                    { ...register(
                                        "email",
                                        {
                                            required: { value: true, message: "E-Mailは必須です" },
                                        },
                                    ) }
                                />
                            </div>
                        </div>
                        { errors.email ? (
                            <div className="field">
                                <p className="help is-danger">
                                    { errors.email.message }
                                </p>
                            </div>
                        ) : null }
                        <div className="field">
                            <label className="label" htmlFor={'tel'}>
                                お電話番号
                            </label>
                            <div className="control">
                                <input
                                    className="input"
                                    type={'tel'}
                                    required={false}
                                    disabled={isSubmitting}
                                    { ...register("tel") }
                                />
                            </div>
                        </div>
                        <div className="field">
                            <label className="label" htmlFor={'message'}>
                                お問い合わせ内容 <span className="has-text-info is-size-7">※最大1000文字</span> <span className="has-text-danger is-size-7">※必須</span>
                            </label>
                            <div className="control">
                                <textarea
                                    className="textarea"
                                    required={true}
                                    disabled={isSubmitting}
                                    { ...register(
                                        "message",
                                        {
                                            required: { value: true, message: "お問い合わせ内容は必須です" },
                                            maxLength: { value: 1000, message: "内容は1000文字以内で入力してください"}
                                        },
                                    ) }
                                />
                            </div>
                        </div>
                        { errors.message ? (
                            <div className="field">
                                <p className="help is-danger">
                                    { errors.message.message }
                                </p>
                            </div>
                        ) : null }
                        <div className="field">
                            <button
                                className={`button is-link ${isSubmitting ? "is-loading" : ""}`}
                                type="submit"
                                disabled={isSubmitting || !isValid}
                            >送信</button>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    )
}

export default Index
